exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".auto-dialer--3FmhqXGqF1AcSPkchLYdvD {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.auto-dialer--3FmhqXGqF1AcSPkchLYdvD > p {\n  margin-top: .5rem;\n}\n", ""]);

// exports
exports.locals = {
	"unknownContainer": "auto-dialer--3FmhqXGqF1AcSPkchLYdvD",
	"unknownContainer": "auto-dialer--3FmhqXGqF1AcSPkchLYdvD"
};